import React from 'react';
import { UserViews } from './viewsManagement/userViews';
import { HelpCenterManagement } from './helpCenterManagement/HelpCenterManagement';
import { AdminCenterManagement } from './adminCenterManagement/AdminCenterManagement';
import { useLocation } from 'react-router-dom';
import { ItAdminCenterManagement } from './itAdminCenterManagement/ItAdminCenterManagement';
import { RoutePath } from '../types/RoutePath';

export const SettingsContent: React.FC = () => {
  const { pathname } = useLocation();

  switch (pathname) {
    case `/${RoutePath.SETTINGS}/${RoutePath.SETTINGS_VIEWS}`:
      return <UserViews />;
    case `/${RoutePath.SETTINGS}/${RoutePath.SETTINGS_HELP_CENTER}`:
      return <HelpCenterManagement />;
    case `/${RoutePath.SETTINGS}/${RoutePath.SETTINGS_ADMIN_CENTER}`:
      return <AdminCenterManagement />;
    case `/${RoutePath.SETTINGS}/${RoutePath.SETTINGS_IT_ADMIN_CENTER}`:
      return <ItAdminCenterManagement />;
    default:
      return <></>;
  }
};
